import { useGetIdsReferencesIdentityproofs } from '@toktokdoctech/tokapi-client'

const useGetIdentityProof = () => {
    const { data, isLoading, error } = useGetIdsReferencesIdentityproofs()

    const getIdentityProof = (value: number) => data?.find((x) => x?.value === value)

    return {
        getIdentityProof,
        loading: isLoading,
        error,
    }
}

export default useGetIdentityProof
